import { translate } from '../../../App/Internationalization';
import images from '../../../config/local/images';
import LinkButton from '../../LinkButton';
import React from 'react';

export default class UpgradeButton extends React.Component {
	render() {
		return (
			<LinkButton
				className="button button button-lg button-icon w-fit"
				icon={images.icons.subscription}
				iconClass="icon icon-fill-fg"
				to={this.props.to}
			>
				{translate('subscription.cta.button')}
			</LinkButton>
		);
	}
}
